import { render } from "./UsersSettings.vue?vue&type=template&id=63cefd0c"
import script from "./UsersSettings.vue?vue&type=script&lang=js"
export * from "./UsersSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__